<template>
  <v-dialog v-model="show" persistent width="70%">
    <v-card>
      <v-app-bar dark text color="secondary" dense>
        <v-spacer></v-spacer>
        <action-button type="cancel" @click="close" />
      </v-app-bar>
      <v-card-text class="pa-1">
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <div class="message-box pa-4">
                <p class="font-weight-bold" v-if="log && log.type == 'email'">{{ $t('notificationtemplates.subject')  }}:</p>
                <span v-if="log && log.subject" v-html="log.subject"></span>

                <p class="font-weight-bold mt-2">{{ $t('notifications.body')  }}:</p>
                <span v-if="log && content" v-html="content"></span>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean },
    log: { type: Object }
  },
  data() {
    return {
      content: null
    }
  },
  watch: {
    show: {
      handler() {
        if (this.show) {
          this.init()
        }
      }
    }
  },
  methods: {
    async init() {
      if (this.log) {
        this.content = this.log.message

        if (this.log.type == "sms") {
          this.content = this.content.replace(/(?:\r\n|\r|\n)/g, "<br>")
        }
      }
    },
    close() {
      this.$emit("callback_close_preview_log")
    }
  }
}
</script>
<style>
.message-box p {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
